import { environment } from '../../../../environments/environment';
import { ClientIdTypeEnum } from '../../enum/client-id.enum';

export const initialClientIdState = environment.defaultClientId as ClientIdTypeEnum;
